import { Box, useResponsive } from '@ghq-abi/design-system';

import { DesktopMenu, ErrorBoundary, Header } from '~/app/components';
import { useFullscreen } from '~/app/contexts/FullscreenContext';
import { LcmUserSession } from '~/shared/auth/types/next-auth';
import { useStellarWidget } from '~/shared/hooks/useStellarWidget';

import { StyledContent, StyledWrapper } from './styles';

type AppTemplateProps = {
  children: React.ReactNode;
  session?: LcmUserSession;
};

export function AppTemplate({ children, session }: AppTemplateProps) {
  useStellarWidget();

  const fullscreen = useFullscreen();
  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });

  if (!session?.user) return null;

  return (
    <>
      {fullscreen.deactivated && <Header />}

      <StyledWrapper fullscreen={fullscreen.activated}>
        {fullscreen.deactivated && !isMobile && <DesktopMenu />}

        <StyledContent as="main" fullscreen={fullscreen.activated}>
          <ErrorBoundary inApp>
            <Box css={{ flex: 1 }}>{children}</Box>
          </ErrorBoundary>
        </StyledContent>
      </StyledWrapper>
    </>
  );
}
